import React from 'react'
import { DeleteIcon, PencilIcon, SortableRow } from '../ManageModalControls.jsx'
import { getFieldName, getFieldType } from './fieldTypes.jsx'

const FieldRow = ({ item, index, onRename, onDelete }) => {
  const [hovered, setHovered] = React.useState(false)
  const [editing, setEditing] = React.useState(false)
  const [name, setName] = React.useState('')
  const inputRef = React.useRef(null)
  const fieldName = getFieldName(item)
  const fieldType = getFieldType(item.type)

  React.useEffect(() => {
    if (editing && inputRef.current) inputRef.current.focus()
  }, [editing])

  const startEdit = () => {
    setName(fieldName)
    setEditing(true)
  }

  const saveEdit = () => {
    const next = name.trim()
    setEditing(false)
    if (next && next !== fieldName) onRename(item, next)
  }

  return (
    <SortableRow
      id={item.id}
      index={index}
      className={`manage-modal__row ${hovered ? 'is-hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className='manage-modal__field-icon' aria-hidden='true'>{fieldType.icon}</span>
      {editing
        ? (
          <input
            ref={inputRef}
            className='manage-modal__name-input glass'
            value={name}
            maxLength={100}
            onChange={event => setName(event.target.value)}
            onBlur={saveEdit}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                event.preventDefault()
                event.currentTarget.blur()
              }
              if (event.key === 'Escape') setEditing(false)
            }}
            aria-label='Field name'
          />
          )
        : (
          <button type='button' className='manage-modal__item-name' title={fieldName} onClick={startEdit}>
            {fieldName}
          </button>
          )}
      {hovered && !editing && (
        <button type='button' className='manage-modal__edit' onClick={startEdit} aria-label={`Rename ${fieldName}`}>
          <PencilIcon />
        </button>
      )}
      <div className='manage-modal__counts'>
        <span>{fieldType.label}</span>
      </div>
      <button
        type='button'
        className='manage-modal__delete'
        aria-label={`Delete ${fieldName} field`}
        onClick={() => onDelete(item)}
      >
        <DeleteIcon />
      </button>
    </SortableRow>
  )
}

export default FieldRow
